import type { PrimaryPageAction } from "@octopusdeploy/design-system-components";
import { EmptyStatePlatformHubIllustration, EmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import { OctoLink } from "@octopusdeploy/utilities";
import type React from "react";
import RequestFreeTrialUpsellCallout from "~/components/Callout/RequestFreeTrialUpsellCallout";
type PlatformHubUpsellContentProps = {
    title: string;
    description: React.ReactNode;
    featureName: string;
    onRequestTrial: (repository: Repository) => Promise<void>;
    onTrialRequested?: () => void;
    trackOpeningRequestDialog?: () => void;
    compact?: boolean;
};
export function PlatformHubUpsellContent({ title, description, featureName, onRequestTrial, onTrialRequested, trackOpeningRequestDialog, compact = false }: PlatformHubUpsellContentProps) {
    const platformHubDocsLink = OctoLink.Create("platform-hub-docs");
    const primaryAction: PrimaryPageAction = {
        type: "custom",
        key: "request-trial",
        content: (<RequestFreeTrialUpsellCallout featureName={featureName} onRequestTrial={onRequestTrial} onTrialRequested={onTrialRequested} docsLink={platformHubDocsLink} docsLabel={"Docs: Platform Hub"} dialogTitle={`Request Free Trial of ${featureName}`} trackOpeningRequestDialog={trackOpeningRequestDialog}>
                {featureName} {featureName === "Platform Hub" ? "is" : "are"} only available on Enterprise tier. Contact Sales or request a free trial below.
            </RequestFreeTrialUpsellCallout>),
    };
    const content = <EmptyStateOnboarding title={title} image={<EmptyStatePlatformHubIllustration />} primaryAction={primaryAction} description={description}/>;
    return compact ? <div style={{ marginTop: "-16px" }}>{content}</div> : content;
}
